import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class SchedulesVacationsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      schedule_grade_group_staff_vacations: [],
      planning_vacation_staffs: [],
    };

    this.export = this.export.bind(this);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.schedule_grade_group_staff_vacations !== 'undefined') {
      this.setState({
        schedule_grade_group_staff_vacations: newProps.schedule_grade_group_staff_vacations,
        planning_vacation_staffs: newProps.planning_vacation_staffs,
        planning_vacation_staffs_total: newProps.planning_vacation_staffs_total,
        sg_ids: newProps.sg_ids,
        loaded: 1,
      });
    }
  }


  export(event) {
    this.handleAlert('', '', 'open');
    var datasave = {
      schedule_grade_ids: this.state.sg_ids,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    self.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/exportar/escala/unificada/ferias', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h4 className="page-title">Colaboradores escalados de férias</h4>
  <div className="clearfix"></div>
  <hr/>
  <button className="btn btn-success pull-left" onClick={() => {this.export()}}><i className="fa fa-fw fa-file-pdf-o"></i>Exportar XLSX</button>
  <div className="clearfix"></div>
  <BootstrapTable data={self.state.schedule_grade_group_staff_vacations} pagination={true} striped={true} hover={true} exportCSV={false} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há escalas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
    <TableHeaderColumn dataField="inscription" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Matrícula</TableHeaderColumn>
    <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nome</TableHeaderColumn>
    <TableHeaderColumn dataField="base" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Base Origem</TableHeaderColumn>
    <TableHeaderColumn dataField="regime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Regime de Trabalho</TableHeaderColumn>
    <TableHeaderColumn dataField="role" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Função</TableHeaderColumn>
    <TableHeaderColumn dataField="date_start" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data de Início</TableHeaderColumn>
    <TableHeaderColumn dataField="date_finish" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data de Término</TableHeaderColumn>
    <TableHeaderColumn dataField="quantity" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Quantidade de Dias</TableHeaderColumn>
  </BootstrapTable>
  <hr/>
  <h4 className="page-title">Colaboradores escalados em planejamento de férias</h4>
  <hr/>

  <BootstrapTable data={self.state.planning_vacation_staffs} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há colaboradores em planejamento de férias'}} search={true} multiColumnSearch={true} searchPlaceholder='Procurar'>
    <TableHeaderColumn dataField="inscription" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Matrícula</TableHeaderColumn>
    <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nome</TableHeaderColumn>
    <TableHeaderColumn dataField="base" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Base Origem</TableHeaderColumn>
    <TableHeaderColumn dataField="regime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Regime de Trabalho</TableHeaderColumn>
    <TableHeaderColumn dataField="role" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Função</TableHeaderColumn>
    <TableHeaderColumn dataField="date_start" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data de Início</TableHeaderColumn>
    <TableHeaderColumn dataField="date_finish" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data de Término</TableHeaderColumn>
    <TableHeaderColumn dataField="quantity" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Quantidade de Dias</TableHeaderColumn>
  </BootstrapTable>
  <hr/>
  <h4 className="page-title">Total de Colaboradores de Férias</h4>
  <hr/>
  <BootstrapTable data={self.state.planning_vacation_staffs_total} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há colaboradores em planejamento de férias'}} search={true} multiColumnSearch={true} searchPlaceholder='Procurar'>
    <TableHeaderColumn dataField="base" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Base Origem</TableHeaderColumn>
    <TableHeaderColumn dataField="regime" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Regime de Trabalho</TableHeaderColumn>
    <TableHeaderColumn dataField="quantity" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Qtd. Colaboradores - Férias</TableHeaderColumn>
  </BootstrapTable>
</div>
    );
  }
}

export default SchedulesVacationsTab;



// WEBPACK FOOTER //
// ./src/Components/Schedules/Elements/SchedulesVacationsTab.js